import React, {Component} from 'react';
import classes from './Toggler.css';

class Toggler extends Component{
    render () {
        return (
            <div className = {classes.Toggler}>
                    <a href="mailto:kalexamhai19@gmail.com?subject=Feedback!" target="_blank" rel="noopener noreferrer"> <i className="fa fa-envelope-o"/></a>                    
                </div>
        )
    }
}

export default Toggler;



// WEBPACK FOOTER //
// ./src/components/Toolbar/Toggler/Toggler.js